import src from "IMAGE";
export default { src, width: 273, height: 191, blurWidth: 0, blurHeight: 0};
